import { Reveal } from "@/components/shared/Reveal";
import { Container, SectionLabel } from "@/components/shared/Primitives";
import { RadarRings } from "@/components/shared/Decorations";
import { tint } from "@/data/site";

export default function Privacy() {
  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="pointer-events-none absolute -left-44 -top-36 h-[600px] w-[600px] opacity-50" style={{ color: "var(--page-accent)" }}>
          <RadarRings className="h-full w-full" />
        </div>
        <Container className="relative z-10 pb-14 pt-16 lg:pt-24">
          <Reveal>
            <h1 className="font-display mt-7" style={{ fontSize: "clamp(42px, 7vw, 96px)", lineHeight: 0.9, letterSpacing: "0.02em", color: "var(--text-0)" }}>
              Privacy Policy
            </h1>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-5 text-[14px]" style={{ color: "var(--text-3)" }}>
              Last updated: June 2025
            </p>
          </Reveal>
        </Container>
      </section>

      {/* BODY */}
      <section className="pb-20 lg:pb-28">
        <Container>
          <div className="mx-auto max-w-[720px] space-y-8 text-[15px] leading-relaxed" style={{ color: "var(--text-1)" }}>
            <Reveal>
              <p>
                Emailink Studio (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) operates the website at{" "}
                <a href="https://emailink.studio" className="underline transition-colors hover:text-[color:var(--text-0)]" style={{ color: "var(--page-accent)" }}>
                  emailink.studio
                </a>{" "}
                and provides agency services, software applications, and related products. This Privacy Policy explains how we
                collect, use, and protect your personal information.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>1. Information We Collect</h2>
              <p>We collect information you voluntarily provide to us:</p>
              <ul className="ml-6 mt-2 list-disc space-y-1">
                <li><strong>Contact information:</strong> your name, email address, phone number, and company name when you fill out our contact form or book a call.</li>
                <li><strong>Communication data:</strong> messages you send us, questions, project details, and feedback.</li>
                <li><strong>Booking information:</strong> when you schedule a call via Calendly, the information you provide to Calendly is governed by their privacy policy.</li>
              </ul>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="ml-6 mt-2 list-disc space-y-1">
                <li>Respond to your inquiries and provide our services</li>
                <li>Schedule and manage appointment bookings</li>
                <li>Send occasional updates if you subscribe to our newsletter (with your consent)</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>3. Third-Party Services</h2>
              <p>We use the following third-party services that may process your data:</p>
              <ul className="ml-6 mt-2 list-disc space-y-1">
                <li><strong>Calendly</strong> — for scheduling consultations. Data submitted via Calendly is subject to their privacy policy.</li>
                <li><strong>Beehiiv</strong> — for future newsletter delivery (not yet connected). When activated, subscriber data will be subject to Beehiiv&apos;s privacy policy.</li>
              </ul>
              <p className="mt-3">We do not sell your personal information to third parties.</p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>4. Cookies</h2>
              <p>
                Our website may use minimal cookies for functionality (e.g., theme preference). We do not use
                tracking cookies or analytics cookies. You can control cookie settings through your browser.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>5. Data Retention</h2>
              <p>
                We retain your personal information only as long as necessary to provide our services or
                as required by law. You may request deletion of your data at any time by contacting us.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>6. CAN-SPAM Compliance</h2>
              <p>
                We comply with the CAN-SPAM Act. If you receive marketing emails from us, each email will
                include a clear unsubscribe link. You can opt out at any time, and we will honor your request promptly.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>7. Your Rights</h2>
              <p>
                You have the right to access, correct, or delete your personal information held by us.
                To exercise these rights, contact us at{" "}
                <a href="mailto:jordan@emailink.io" className="underline transition-colors hover:text-[color:var(--text-0)]" style={{ color: "var(--page-accent)" }}>
                  jordan@emailink.io
                </a>.
              </p>
            </Reveal>

            <Reveal delay={0.04}>
              <h2 className="text-lg font-semibold" style={{ color: "var(--text-0)" }}>8. Contact</h2>
              <p>
                Emailink Studio<br />
                7901 4th St N STE 300<br />
                St. Petersburg, FL 33702, USA<br />
                Email:{" "}
                <a href="mailto:jordan@emailink.io" className="underline transition-colors hover:text-[color:var(--text-0)]" style={{ color: "var(--page-accent)" }}>
                  jordan@emailink.io
                </a>
              </p>
            </Reveal>
          </div>
        </Container>
      </section>
    </div>
  );
}
